<template>
  <div class="memory">
    <img
      class="memory__brain"
      src="/assets/brain.svg"
      alt="TubeChopper brain"
    />
    <p v-if="!hasMemory">You brain is empty</p>
    <MemorySlot
      v-for="memorySlot in memorySlots"
      :key="memorySlot.nr"
      :memorySlot="memorySlot"
    />
  </div>
</template>

<script>
import "@/compiled-icons/archive";
import "@/compiled-icons/video";
import MemorySlot from "@/components/MemorySlot.vue";

export default {
  name: "Memory",
  components: {
    MemorySlot
  },
  computed: {
    memorySlots() {
      return this.$store.getters.getUsedMemorySlots;
    },
    hasMemory() {
      const memoryKeys = Object.keys(this.memorySlots);
      return typeof memoryKeys !== "undefined" && memoryKeys.length > 0
        ? true
        : false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../partials/vars";
.memory {
  text-align: center;

  &__brain {
    width: 100px;
    margin-bottom: 25px;
  }
}
</style>
